<template>
  <div class="d-lg-flex half">
    <div class="bg order-1 order-md-2" :style="{ backgroundImage: `url(${bannerWeb})` }"></div>

    <div class="contents order-2 order-md-1">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="content col-md-7">
            <div class="d-flex align-items-center justify-content-center">
              <img :src="logo" :style="{ height: 'var(--logo-height-login)', width: 'var(--logo-width-login)' }" alt="" />
              <div
                v-if="logo && logo.includes('logosetneg')"
                class="setneg-title ml-3"
                style="align-self: center;"
              >
                Kementerian Sekretariat Negara<br>
                Republik Indonesia
              </div>
            </div>
            <p
              :class="[
                'login-title',
                logo && logo.includes('logomedan') ? 'mt-6' :
                logo && logo.includes('Garuda-logo') ? 'mt-6' : ''
              ]"
            >
              Login to Media Analytic
            </p>
            <form action="#" method="post">
              <v-alert v-if="alertErrors" type="error" class="mt-4">
                {{ errors }}
              </v-alert>
              <v-form v-model="formValid" ref="form" @submit.prevent="validateForm">
                <div class="form-group first mb-2">
                  <v-text-field
                    v-model="userName"
                    outlined
                    dense
                    color="var(--color-theme)"
                    prepend-inner-icon="mdi-account"
                    label="Username"
                    placeholder="johndoe"
                    :rules="[v => !!v || 'Username is required']"
                  ></v-text-field>
                </div>

                <div class="form-group last">
                  <v-text-field
                    v-model="password"
                    prepend-inner-icon="mdi-lock"
                    :append-icon="showpassword ? 'mdi-eye' :'mdi-eye-off'"
                    persistent-hint
                    outlined
                    dense
                    color="var(--color-theme)"
                    label="Password"
                    placeholder="*******"
                    :type="showpassword ? 'text' : 'password'"
                    :rules="[v => !!v || 'Password is required']"
                    @click:append="showpassword = !showpassword"
                  ></v-text-field>
                </div>

                <p style="font-family: Open Sans; font-size: 14px;">
                  Calculate This Operation:
                </p>

                <div>
                  <v-row>
                    <v-col cols="auto">
                      <canvas ref="captchaCanvas" width="150" height="70"></canvas>
                    </v-col>
                    <v-col>
                      <v-btn
                        class="white--text"
                        style="border-radius: 8px"
                        color="var(--color-theme)"
                        small
                        @click="generateCaptcha()"
                      >
                        Refresh CAPTCHA
                      </v-btn>
                      <v-text-field
                        v-model="userInput"
                        class="mt-2 custom-text-field"
                        color="var(--color-theme)"
                        label="Enter CAPTCHA"
                        outlined
                        clearable
                        dense
                        :rules="[v => !!v || 'CAPTCHA is required']"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>

                <v-btn
                  class="btn-block elevation-0 white--text"
                  style="text-decoration:none; font-size: 16px;"
                  color="var(--color-theme)"
                  type="submit"
                  block
                  large
                  rounded
                  dark
                  :loading="btnLoad"
                  @click="login"
                >
                  {{ btnLoad ? 'Loading...' : 'Login' }}
                </v-btn>

                <!-- <v-btn
                  class="btn-block elevation-0 white--text"
                  style="text-decoration:none;"
                  color="#0471A5"
                  block
                  large
                  rounded
                  dark
                  :loading="btnLoad"
                  @click="socket_send"
                >
                  {{ btnLoad ? 'Loading...' : 'cek socket' }}
                </v-btn> -->
              </v-form>

              <div class="form-group d-flex justify-content-between mb-1">
                <label class="label mx-auto mt-3 font-weight-normal">
                  <a href="#" class="font-weight-medium" style="text-decoration:none;">
                    Forgot Password ?
                  </a>
                </label>
              </div>
              <div class="form-group d-flex justify-content-between">
                <label class="label mx-auto mt-1 font-weight-normal">
                  <p class="text-center mb-0 text-muted font-weight-light">
                    Don't have account?
                    <v-btn
                      style="text-decoration:none;"
                      color="var(--color-theme)"
                      text
                      to="/register"
                    >
                      Register here
                    </v-btn>
                  </p>
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="JavaScript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.18/vue.min.js"></script>
<script>
// import cookie from "cookie-signature";
import axios from "axios";
import { decryptionData, datetimenow, trackEvent, clearUmamiSession } from '@/components/utils/utils.js';

import { createRouter } from '@/router/index.js';
import io from 'socket.io-client';

export default {
  name: 'login',
  data () {
    return {
      logo: null,
      bannerWeb: null,
      formValid: false,
      btnLoad: false,
      showpassword: false,
      userName: "",
      password: "",
      alertErrors: false,
      errors: null,
      userInput: "",
      captchaText: "",
      socket: "",
    }
  },
  async created() {
    await this.loadAssetsTheme();
  },
  mounted() {
    this.generateCaptcha();
    this.loadCekSessionLogin();
  },
  methods: {
    async loadAssetsTheme() {
      try {
        const appTitle = window.APP_CONFIG?.VUE_APP_TITLE || process.env.VUE_APP_TITLE;
        const assetsModule = appTitle == "Websitemedan"
          ? await import('@/constants/asset-logo-MedAn.js')
          : await import('@/constants/asset-logo-Garuda.js');

        this.logo = assetsModule.LOGO_WEB;
        this.bannerWeb = assetsModule.BANNER_WEB;
      } catch (error) {
        console.error('Failed to load environment assets:', error);
      }
    },
    async loadCekSessionLogin() {
      axios.post("decode-token",
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        if (response.status == 200) {
          // ini jangan dirubah ya 
          let menuPrivilage = JSON.parse(localStorage.getItem('menuPrivilage'));
          let module_id = (localStorage.getItem('module'));

          for (const menuact of menuPrivilage) {
            if (module_id == menuact.MODULE_ID ) {
              console.log(menuact);
              this.$router.replace(menuact.MODULE_URL);
            }
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
    },
    async socket_send() {
      this.socket = io(process.env.VUE_APP_BASE_URL_API); // Connect to your Socket.io server
      this.socket.emit('message', {
        type: 'notifikasi_register',
        text: 'Irfan created Python Notebook on Video Game Sales Data!',
        username: 'Username',
        url: '/registrasiuser',
        date: datetimenow(),
      });
    },
    validateForm() {
      if (this.$refs.form.validate()) {
        this.login();
      }
    },
    async login() {
      this.btnLoad = true;
      try {
        if (this.userInput == this.captchaAnswer) {
          const data = await axios.post("login", {
            username: this.userName,
            password: this.password
          })

          // localStorage.setItem("encript",data.data.status)//mengirim token ke local storage
          let dataEncrypt = decryptionData(data.data.token);

          localStorage.setItem("token_app", dataEncrypt.token)//mengirim token ke local storage

          localStorage.setItem("username", dataEncrypt.username)//mengirim token ke local storage
          localStorage.setItem("email", dataEncrypt.email)//mengirim token ke local storage
          localStorage.setItem("group", JSON.stringify(dataEncrypt.group))//mengirim token ke local storage
          localStorage.setItem("nik", JSON.stringify(dataEncrypt.nik))//mengirim token ke local storage

          clearUmamiSession();
          if (dataEncrypt.nik == null) {
            localStorage.setItem("tmpmenuPrivilage", JSON.stringify(dataEncrypt.menu_access))//mengirim token ke local storage
            localStorage.setItem("menuPrivilage", '')//mengirim token ke local storage

            this.trackLoginSuccess(dataEncrypt, '/profile');
            window.location.href = '/profile'; // Full reload
          } else {
            this.$store.commit("menuPrivilage", {
              //send menu prifilage users to store
              menu_access: dataEncrypt.menu_access,
            });
            localStorage.setItem("menuPrivilage", JSON.stringify(dataEncrypt.menu_access))//mengirim token ke local storage
            localStorage.setItem("tmpmenuPrivilage", JSON.stringify(dataEncrypt.menu_access))//mengirim token ke local storage

            const redirectUrl = dataEncrypt.menu_access[0].MODULE_CHILD[0].MODULE_URL;
            this.trackLoginSuccess(dataEncrypt, redirectUrl);
            window.location.href = redirectUrl;
          }
        } else {
          this.btnLoad = false;

          this.alertErrors = true;
          this.errors = 'Incorrect CAPTCHA. Please try again.';
          this.generateCaptcha(); // Generate a new CAPTCHA if the input is incorrect

          trackEvent('login-failed', {err: 'CAPTCHA'});
        }
      } catch(e) {
        this.alertErrors = true;
        setTimeout(() => {
          this.alertErrors = false;
        }, 10000);
        if (e.response) {
          this.errors = e.response.data.msg;
        } else {
          this.errors = "API Login refused to connect";
        }
        this.btnLoad = false;
      }
    },
    trackLoginSuccess(dataEncrypt, redirectUrl) {
      try {
        if (window.umami) {
          // if (typeof window.umami.identify === 'function') {
          //   window.umami.identify(this.userName, { group: dataEncrypt.group });
          // }
          trackEvent('login-success', { user: this.userName });
          // if (typeof window.umami.trackView === 'function') {
          //   window.umami.trackView(redirectUrl);
          // }
        }
      } catch (trackErr) {
        console.warn('Tracking failed (non-critical):', trackErr.message);
      }
    },
    generateCaptcha() {
      // Generate two random numbers between 1 and 10 for the math problem
      const num1 = Math.floor(Math.random() * 10) + 1;
      const num2 = Math.floor(Math.random() * 10) + 1;

      // Randomly select an operator
      const operators = ['+', '-', 'x'];
      const operator = operators[Math.floor(Math.random() * operators.length)];

      // Calculate the answer and store it for validation
      let answer;
      switch (operator) {
          case '+':
              answer = num1 + num2;
              break;
          case '-':
              answer = num1 - num2;
              break;
          case 'x':
              answer = num1 * num2;
              break;
      }
      this.captchaAnswer = answer;

      // Set the CAPTCHA text to show the math problem
      this.captchaText = `${num1} ${operator} ${num2}`;
      // alert(this.captchaAnswer)
      // Draw the CAPTCHA on the canvas
      const canvas = this.$refs.captchaCanvas;
      const ctx = canvas.getContext('2d');

      // Clear the canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Set background color and fill the canvas
      ctx.fillStyle = '#e0e0e0';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Set text properties for the math problem
      ctx.font = '30px Arial';
      ctx.fillStyle = '#333';
      ctx.setTransform(1, 0.1, -0.1, 1, 0, 0); // Slightly skew the text for a CAPTCHA effect

      // Draw the math problem on the canvas
      ctx.fillText(this.captchaText, 20, 35);

      // Optionally, add some noise or lines for extra security
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = '#999';
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }
    },

    generateCaptchaText() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      this.captchaText = Array.from({ length: 6 })
        .map(() => characters.charAt(Math.floor(Math.random() * characters.length)))
        .join('');

      const canvas = this.$refs.captchaCanvas;
      const ctx = canvas.getContext('2d');

      // Clear the canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Set background color and fill the canvas
      ctx.fillStyle = '#e0e0e0';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Set text properties
      ctx.font = '30px Arial';
      ctx.fillStyle = '#333';
      ctx.setTransform(1, 0.1, -0.1, 1, 0, 0); // Slightly skew the text for a CAPTCHA effect

      // Draw the CAPTCHA text on the canvas
      ctx.fillText(this.captchaText, 20, 35);

      // Optionally, add some noise or lines for extra security
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = '#999';
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.setneg-title {
  margin-left: var(--title-margin-left);
  font-family: var(--title-font-family);
  font-weight: var(--title-font-weight);
  font-style: var(--title-font-style);
  font-size: 16px;
  line-height: var(--title-line-height);
  letter-spacing: var(--title-letter-spacing);
  color: var(--title-color);
}
.login-title {
  font-family: 'Open Sans';
  font-weight: 700;
  font-style: bold;
  font-size: 16.6px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
}

body {
  font-family: 'Open Sans';
  background-color: #fff;
}

p {
  color: #616063;
}

a:hover {
  text-decoration: none !important;
}

.content {
  padding: 5rem 0;
  margin-left: 7rem;
  margin-right: 7rem;
}

.half, .half .container > .row {
  height: 100%;
  min-height: 500px;
}

@media (max-width: 991.98px) {
  .half .bg {
    height: 400px;
  }
}

.half .contents {
  background: #ffffff;
}

.half .contents, .half .bg {
  width: 50%;
}

@media (max-width: 1199.98px) {
  .half .contents, .half .bg {
    width: 100%;
  }
}
.half .contents .form-control, .half .bg .form-control {
  border: none;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 54px;
  background: #fff;
}
.half .contents .form-control:active, .half .contents .form-control:focus, .half .bg .form-control:active, .half .bg .form-control:focus {
  outline: none;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.half .bg {
  background-size: cover;
  background-position: center;
}

.half a {
  color: #888;
  text-decoration: underline;
}

.half .btn {
  height: 54px;
  padding-left: 30px;
  padding-right: 30px;
}
</style>